import { IconRobot } from '@tabler/icons-react';
import { Button } from '@/shared/ui';
import { haptic } from '@/shared/lib/haptic';
import { useCoordinatorStatus, useRequestCoordinatorRun } from './useCoordinator';
import type { CoordinatorState } from './api';

const LABEL: Record<CoordinatorState, string> = {
  idle: 'Запустить координатора',
  queued: 'В очереди…',
  running: 'В работе…',
  busy: 'Занят (другой пациент)',
  offline: 'Координатор офлайн',
};

/**
 * Кнопка ручного запуска AI-координатора. Состояние берётся из GET /coordinator/status
 * (поллинг). Пока идёт проход — «В работе» и задизейблена. Пациент подставляется
 * автоматически из X-Patient-Id (client.ts) — кнопка работает для открытой карты.
 */
export function CoordinatorButton({ block = true }: { block?: boolean }) {
  const { data, isLoading } = useCoordinatorStatus();
  const run = useRequestCoordinatorRun();

  const status: CoordinatorState = data?.status ?? 'idle';
  const inFlight = status === 'running' || status === 'queued';
  const disabled =
    isLoading || inFlight || status === 'busy' || status === 'offline' || run.isPending;
  const label = isLoading ? 'Координатор…' : LABEL[status];

  const lastRun = status === 'idle' ? data?.last_run : null;
  const lastRunText =
    lastRun?.reason === 'egress'
      ? 'Прошлый запуск отменён: egress не из DE'
      : lastRun?.summary
        ? `Последний проход: ${lastRun.summary}`
        : null;

  return (
    <div style={{ width: block ? '100%' : undefined }}>
      <Button
        size="sm"
        block={block}
        variant="secondary"
        loading={inFlight || run.isPending}
        disabled={disabled}
        icon={<IconRobot size={14} />}
        onClick={() => {
          haptic('light');
          run.mutate();
        }}
      >
        {label}
      </Button>
      {lastRunText && (
        <div
          style={{
            fontSize: 11,
            color: 'var(--text-secondary)',
            marginTop: 4,
            textAlign: 'center',
          }}
        >
          {lastRunText}
        </div>
      )}
    </div>
  );
}
